import { FaSearch } from "react-icons/fa";

export default function SearchBar({ value, onChange }) {
  return (
    <label className="relative block">
      <span className="sr-only">Search products</span>
      <FaSearch className="absolute left-4 top-1/2 -translate-y-1/2 text-slate-400" />
      <input value={value} onChange={(event) => onChange(event.target.value)} placeholder="Search by product, brand or specification" className="w-full rounded-xl border border-line bg-white py-3 pl-11 pr-4 text-sm shadow-sm transition focus:border-primary focus:ring-2 focus:ring-emerald-100" />
    </label>
  );
}
